
/**
 *
 * @returns
 */
export default async function Initialize() {

    // Astro Web Maps, has the tile base data for the map of each planetary body
    const astroWebMaps =
        "https://astrowebmaps.wr.usgs.gov/webmapatlas/Layers/maps.json";

    // Async tracking
    let fetchStatus = {};
    let fetchPromise = {};
    let jsonPromise = {};

    // Fetched Maps
    let mapsJson = {};

    // Combined Data
    let aggregateMapList = {};

    // Init
    fetchStatus[astroWebMaps] = "Not Started";
    fetchPromise[astroWebMaps] = "Not Started";
    jsonPromise[astroWebMaps] = "Not Started";
    mapsJson[astroWebMaps] = [];

    // Fetch JSON and read into object
    async function ensureFetched(targetUrl) {
        if (fetchStatus[targetUrl] === "Not Started") {
            fetchStatus[targetUrl] = "Started";
            fetchPromise[targetUrl] = fetch(
                targetUrl
            ).then((res) => {
                jsonPromise[targetUrl] = res.json().then((jsonData) => {
                    mapsJson[targetUrl] = jsonData;
                }).catch((err) => {
                    console.log(err);
                });
            }).catch((err) => {
                console.log(err);
            });
        }
        await fetchPromise[targetUrl];
        await jsonPromise[targetUrl];
    }

    ensureFetched(astroWebMaps);
    await ensureFetched(astroWebMaps);

    return mapsJson[astroWebMaps];
}